import { Column } from "react-table";

export const ParentDashboardColumns: Column[] = [
  {
    Header: "Avatar",
    accessor: "avatar",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Class ID",
    accessor: "course_name",
  },
  {
    Header: "Course Start",
    accessor: "course_start",
  },
  {
    Header: "Course End",
    accessor: "course_end",
  },
  {
    Header: "Lvl",
    accessor: "level",
  },
  {
    Header: "Onboarding Quiz",
    accessor: "onboarding_quiz",
  },
];
